<template lang="pug">
  div
    el-dialog(
      :title='modalTitle'
      :visible.sync='showModal'
       width='60%'
       v-loading='loading'
    )
      div
        span.historico Histórico da conversa
        el-collapse(
          v-for='(conversa, index) in historico.content'
          :key='index'
          v-model='panelAtiva[index]'
          accordion
          style='padding: 20px 0px 20px 0px;'
        )
          div.assunto {{ conversa.assunto }}
          el-collapse-item(v-for="(mensagem, index) in conversa.mensagens" :key="index")
            template(slot='title')
              .title-content
                div
                  span {{ mensagem.remetente.nomeRazaoSocial }}
                div
                  span {{ mensagem.dataEnviada | timestamp }}
            span(v-html='mensagem.conteudo')
            div(v-if="mensagem.anexos.length > 0")
              div(v-for="(anexo, index) in mensagem.anexos" :key="index")
                el-divider(v-if="index > 0")
                div.anexos
                  span.anexo-name {{ anexo.nome }}
                  div(class="fa fa-download icone-download" style="color: #666666;" @click="downloadAnexo(anexo)")
            div.sem-anexo(v-else) Não há anexos disponíveis.

      el-form(
        :rules='rules'
        ref='formNotificar'
        :model='formNotificar'
        label-position='top'
        v-if="(conversa && conversa.status !== 'ENCERRADA') || !conversa"
      )
        el-row(:gutter='100')
          el-col(:span='14')
            el-form-item(v-if="!conversa" label='Assunto' prop='assunto')
              el-input(v-model='formNotificar.assunto' placeholder='Assunto')
            el-form-item(v-else label='Status' prop='fecharConversa')
              el-radio-group(v-model='fecharConversa')
                el-radio(:label='true') Fechar conversa
                el-radio(:label='false') Responder mensagem
          el-col.prazo(:span='10' v-if='!fecharConversa')
            el-form-item(label='Prazo para resposta' prop='prazo')
              el-date-picker(
                v-model='formNotificar.prazo'
                placeholder='Selecione'
                type='date'
                :picker-options='pickerOptions'
                format="dd/MM/yyyy"
              )

        .selecionar-modelo(v-if='!fecharConversa')
          el-button(type='primary' @click='listarModelos').botao-modelo
            i(style='padding-right: 5px;').fas.fa-file-alt
            span Modelo

        el-form-item(label='Mensagem' prop='mensagem' v-if='!fecharConversa')
          vue-editor(v-model='formNotificar.mensagem' :editor-toolbar='customToolbar')

        el-form-item(label='Anexos da mensagem' prop='anexos' v-if='!fecharConversa')
          el-upload(
            class="upload-demo"
            drag
            :action='urlUpload'
            :headers="{ Authorization: token }"
            multiple
            :file-list='fileList'
            :on-success='updateAnexosId'
            :before-upload='checkFile'
            :on-remove="removeFile"
          )
            div.el-upload__text
              span Arraste e solte ou clique para selecionar um arquivo.
              span Formatos suportados: png, jpg, jpeg, pdf, doc, docx, zip.
      el-row(type='flex' justify='space-between')
        el-button(@click='fecharModal')
          i(style='padding-right: 5px;').fa.fa-times
          span Cancelar
        el-button(
          :disabled="loading"
          type='primary'
          @click='enviarMensagem'
          v-if="(conversa && conversa.status !== 'ENCERRADA') || !conversa"
        )
          i(style='padding-right: 5px;').fa.fa-share-square
          span Enviar

    modal-modelos(
      :modalOpen='showModelos'
      @close-modal='showModelos = false'
      @usar-modelo='modeloSelecionado = $event, aplicarModelo()'
    )
</template>
<script>
import { VueEditor } from 'vue2-editor';
import { cadastrar, responderMensagem, finalizarConversa, listConversasBySolicitacao } from '@/services/conversaService';
import { findByCaminho } from '@/services/documentoService';
import { AppNotificacao } from 'sicarf-components';
import ModalModelos from '@/components/modalListarModelos.vue';
import store from '@/store';
import { TIPO_CONVERSA } from '@/constants/constants.js';

export default {
  components: {
    VueEditor,
    ModalModelos,
  },
  mixins: [
    AppNotificacao
  ],
  props: {
    solicitacao: {
      type: Object,
      required: true,
    },
    modalOpen: {
      type: Boolean,
      default: false,
    },
    idSolicitacao: {
      type: Number,
      required: false
    },
    dataFimEdital: {
      required: true
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },
  data() {
    return {
      modeloSelecionado: {},
      modalTitle: '',
      fecharConversa: false,
      showModelos: false,
      historico: [],
      formatosPermitidos: ['pdf', 'rar', 'zip', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      formNotificar: {
        assunto: null,
        prazo: null,
        mensagem: null,
        anexos: [],
      },
      panelAtiva: [],
      conversa: null,
      rules: {
        assunto: [
          { required: true, message: 'Defina um assunto', trigger: 'blur' },
          { min: 5, message: 'Assunto precisa ter pelo menos 5 caracteres', trigger: 'change' }
        ],
        prazo: [
          { required: true, message: 'Defina um prazo', trigger: 'blur' }
        ],
        mensagem: [
          { required: true, message: 'A mensagem é obrigatória', trigger: 'blur' }
        ],
        status: [
          { required: true, message: 'Selecione uma ação', trigger: 'blur' }
        ]
      },
      edital: {},
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ clean: true }],
      ],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      urlUpload: `${process.env.VUE_APP_ROOT_URL}/publico/documentoCredenciado/upload`,
      token: `Bearer ${sessionStorage.getItem('@jwt')}`,
      fileList: [],
      loading: false,
    }
  },
  async mounted() {
    this.loading = true;
    this.historico = await listConversasBySolicitacao(this.solicitacao.id, TIPO_CONVERSA.NOTIFICACAO, 0, 999999);

    if (this.historico && this.historico.content.length > 0) {
      this.conversa = this.historico.content[this.historico.content.length - 1];
    }

    if (!this.conversa) {
      this.modalTitle = 'Notificar credenciado';
    } else {
      this.modalTitle = 'Notificações';
    }

    this.loading = false;
  },

  methods: {
    disabledDate(time) {
      const dataFimEditalPlus30 = new Date(this.dataFimEdital)
      dataFimEditalPlus30.setDate(dataFimEditalPlus30.getDate() + 30)
      return time.getTime() > dataFimEditalPlus30.getTime();
    },
    removeFile(file) {
      this.formNotificar.anexos = this.formNotificar.anexos.filter((doc) => doc.nome !== file.name);
    },

    updateAnexosId(file, response) {
      this.formNotificar.anexos.push({ nome: response.name, key: file });
    },

    listarModelos() {
      this.showModelos = true;
    },

    aplicarModelo() {
      if (!this.conversa) {
        this.formNotificar.assunto = this.modeloSelecionado.assunto;
      }
      this.formNotificar.mensagem = this.modeloSelecionado.conteudo;
      this.showModelos = false;
    },

    checkFile(file) {
      const tamanhoValido = file.size / 1024 / 1024 < 15;

      const showLoading = () => {
        store.commit('loader/SET_LOADER')
      }

      const hideLoading = () => {
        store.commit('loader/RESET_LOADER')
      }

      showLoading();

      let aux = file.name.split(".")
      const typeFile = aux[aux.length - 1]

      if (!this.formatosPermitidos.includes(typeFile.toLowerCase())) {
        this.showNotificacao(this.$messages.TIPO_ERROR, 'Formato de arquivo inválido!',
          'Formatos suportados: png, jpg, jpeg, pdf, doc, docx, zip.')
        hideLoading()
        return false;
      }

      if (!tamanhoValido) {
        hideLoading()
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
          'Arquivo deve ter no máximo 15MB de tamanho!')
        hideLoading()
        return false;
      }

      hideLoading()
      return true;
    },

    fecharModal() {
      this.$emit('close-modal');
    },

    async enviarMensagem() {
      if (this.fecharConversa) {
        this.loading = true;
        try {
          const result = await finalizarConversa(this.conversa.id);
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            result
          )
          this.$emit('close-modal');
        } catch (e) {
          console.error(e);
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            this.$messages.ERROR_MESSAGE
          )
          this.loading = false
        }
      } else {
        this.$refs.formNotificar.validate(async (valid) => {
          if (valid) {
            this.loading = true;
            if (!this.conversa) {
              const conversa = {};
              conversa.assunto = this.formNotificar.assunto;
              conversa.idSolicitacao = this.idSolicitacao;
              conversa.mensagens = [{
                conteudo: this.formNotificar.mensagem,
                dataLimiteResposta: this.formNotificar.prazo,
                anexos: this.formNotificar.anexos,
                destinatario: {
                  id: this.solicitacao.credenciado.pessoa.id,
                  email: this.solicitacao.credenciado.pessoa.email,
                  pessoaFisica: {
                    nome: this.solicitacao.credenciado.pessoa.pessoaFisica.nome,
                  }
                }
              }];
              const result = await cadastrar(conversa);
              if (result === 'Não existe edital em andamento') {
                this.showNotificacao(
                  this.$messages.TIPO_WARNING,
                  this.$messages.TITULO_WARNING,
                  this.$messages.SEM_EDITAL_VIGENTE
                )
              } else if (result === "Cadastrado com sucesso") {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  "Conversa iniciada com sucesso."
                )
              }
              this.$emit('close-modal');
              this.loading = false;
            } else {
              this.loading = true;
              const resposta = {};
              resposta.conversa = {};
              resposta.conversa.id = this.conversa.id;
              resposta.conteudo = this.formNotificar.mensagem;
              resposta.dataLimiteResposta = this.formNotificar.prazo;
              resposta.destinatario = {
                id: this.solicitacao.credenciado.pessoa.id,
                email: this.solicitacao.credenciado.pessoa.email,
                pessoaFisica: {
                  nome: this.solicitacao.credenciado.pessoa.pessoaFisica.nome,
                }
              }
              resposta.anexos = this.formNotificar.anexos

              try {
                const result = await responderMensagem(resposta);
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  result
                )
                if (result) {
                  this.$emit('close-modal');
                }
              } catch (e) {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  this.$messages.ERROR_MESSAGE
                )
                this.loading = false
              }
            }
          }
        })
      }
    },
    async downloadAnexo(anexo) {
      const fileLink = document.createElement('a');

      const arquivo = await findByCaminho(anexo.caminho);

      if (arquivo) {
        const fileURL = new Blob([arquivo]);
        fileLink.href = window.URL.createObjectURL(fileURL);

        fileLink.setAttribute('download', anexo.nome);
        document.body.appendChild(fileLink);

        fileLink.click();
      }

      return Promise.resolve();
    },
  }
}
</script>
<style lang="scss" scoped>
.divider {
  border: 1px solid #dfe4ed;
  margin-bottom: 10px;
  margin-top: 10px;
}

.title {
  font-weight: bold;
  font-size: 16px;
  padding-left: 10px;
}

.label {
  font-weight: bold;
  font-size: 15px;
  padding-left: 10px;
}

.paddingTop20 {
  padding-top: 20px;
}

.marginBottom60 {
  margin-bottom: 60px;
}

.el-upload__text {
  background: #d9d9d9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  line-height: 2em;
  height: 7rem;
}

.botao-modelo {
  z-index: 9;
}

.selecionar-modelo {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -70px;
}

.title-content {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.anexos {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  height: 24px;
  color: #666666;
}

.anexo-name {
  margin-left: 12px;
}

.prazo {
  display: flex;
  justify-content: flex-end;
}

.historico {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 25px;
}

.assunto {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 25px;
  margin-left: 20px;
}

</style>
